import request from '@/utils/request'
export const checkData = (uu) => {
    return request.get('/userInfo', {
        params: {
            token: uu
        }
    })
}

export const getOrder = (uu,type,day,tType,id,wxid) => {
    return request.get('/getOrder', {
        params: {
            token: uu,
            type: type,
            day: day,
            timeType: tType,
            id: id,
            wxid: wxid
        }
    })
}
